import { Controller } from '@hotwired/stimulus';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const FALLBACK_DURATION = 5 * DAY;

export default class extends Controller {
  static targets = ['days', 'hours', 'minutes', 'seconds'];

  static values = {
    endTs: { type: Number, default: 0 },
  };

  connect() {
    this.tick();
    this.interval = setInterval(() => this.tick(), SECOND);
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const endTs = this.endTsValue || Date.now() + FALLBACK_DURATION;
    const diff = Math.max(0, endTs - Date.now());

    const days = Math.floor(diff / DAY);
    const hours = Math.floor((diff % DAY) / HOUR);
    const minutes = Math.floor((diff % HOUR) / MINUTE);
    const seconds = Math.floor((diff % MINUTE) / SECOND);

    if (this.hasDaysTarget) this.daysTarget.textContent = this.pad(days);
    if (this.hasHoursTarget) this.hoursTarget.textContent = this.pad(hours);
    if (this.hasMinutesTarget) this.minutesTarget.textContent = this.pad(minutes);
    if (this.hasSecondsTarget) this.secondsTarget.textContent = this.pad(seconds);
  }

  pad(n) {
    return String(n).padStart(2, '0');
  }
}
